<template>
  <div>
    <footer class="footer" :class="{ 'footer-dark': footer == 'footer-dark', 'sidebar': togglesidebar }">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 footer-copyright text-center">
            <p class="mb-0">{{ $t('global.copyright', { year: currentYear }) }}</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'footerpage',
  data() {
    return {
      customizer: false,

    };
  },
  computed: {
    ...mapGetters({
      footer: 'layout/footer'
    }),
    ...mapState({
      togglesidebar: (state) => state.menu.togglesidebar,
    }),
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>
